import { PropsWithChildren } from 'react'
import styles from './OuterTable.module.css'

export function OuterTable({ children }: PropsWithChildren) {
  return <div className={styles.OuterTable}>{children}</div>
}
